import { useEffect, useState } from "react";
import { RelatoriosLayout } from "../../../layouts";
import { responseErros } from "../../../utils";
import {
  FormFiltroAvancadoCaixa,
  FormFiltroAvancadoContasPagar,
  FormFiltroAvancadoContasReceber,
} from "./components";
import {
  CaixaService,
  ConfiguracoesService,
  ContasPagarService,
  ContasReceberService,
  notification,
} from "../../../services";
import {
  PrintCaixaDetalhado,
  PrintContasPagarDetalhado,
  PrintContasReceberDetalhado,
} from "../layouts";
import { PermisoesHelper, responseStreamHelper } from "../../../helpers";
const contasPagarService = new ContasPagarService();
const contasReceberService = new ContasReceberService();
const caixaService = new CaixaService();
const configuracaoService = new ConfiguracoesService();

const RelatoriosFinanceiro = () => {
  const permissoesHelper = new PermisoesHelper();
  const [loading, setLoading] = useState(false);
  const [configuracoes, setConfiguracoes] = useState({});
  const [filtrosAvancados, setFiltrosAvancados] = useState({});
  const [filtrosAplicadosImpressao, setFiltrosAplicadosImpressao] = useState(
    {},
  );

  const subgruposRelatoriosFinanceiros = [
    {
      subgrupo: "Contas a Receber",
      propriedades: [
        {
          name: "601 - Contas a Receber Detalhado",
          layoutImpressao: PrintContasReceberDetalhado,
          permissao: permissoesHelper.temPermisao(
            "relatorio-contas-receber-detalhado",
          ),
          funcaoBuscarDadosRelatorio: buscarContasReceberDetalhado,
          formulario: FormFiltroAvancadoContasReceber,
        },
        // {
        //   name: "702 - Histórico de Pagamentos Recebidos",
        //   layoutImpressao: PrintHistoricoPagamentosReceber,
        //   permissao: permissoesHelper.temPermisao(
        //     "relatorio-historico-pagamentos-contas-receber"
        //   ),
        //   funcaoBuscarDadosRelatorio: buscarHistoricoPagamentos,
        //   formulario: FormFiltroAvancadoHistoricoPagamentosReceber,
        // },
      ],
    },
    {
      subgrupo: "Contas a Pagar",
      propriedades: [
        {
          name: "801 - Contas a Pagar Detalhado",
          tipo: "Detalhado",
          layoutImpressao: PrintContasPagarDetalhado,
          permissao: permissoesHelper.temPermisao(
            "relatorio-contas-pagar-detalhado",
          ),
          funcaoBuscarDadosRelatorio: buscarContasPagarDetalhado,
          formulario: FormFiltroAvancadoContasPagar,
        },
      ],
    },
    {
      subgrupo: "Caixa",
      subgrupoDescricao: "Entrada x Saída",
      propriedades: [
        {
          name: "901 - Movimento de Caixa",
          layoutImpressao: PrintCaixaDetalhado,
          permissao: permissoesHelper.temPermisao("relatorio-caixa-diario"),
          funcaoBuscarDadosRelatorio: buscarRelatorioCaixaDetalhado,
          formulario: FormFiltroAvancadoCaixa,
        },
        {
          name: "902 - Fluxo de Caixa",
          permissao: permissoesHelper.temPermisao("relatorio-fluxo-caixa"),
          dashboard: true,
          dashboardUrl: "/relatorios-financeiro/fluxo-de-caixa",
        },
        {
          name: "903 - Despesas por plano financeiro",
          permissao: permissoesHelper.temPermisao(
            "relatorio-despesas-plano-financeiro",
          ),
          dashboard: true,
          dashboardUrl: "/relatorios-financeiro/despesas-por-plano-financeiro",
        },
        {
          name: "904 - DRE",
          permissao: permissoesHelper.temPermisao("relatorio-dre"),
          dashboard: true,
          dashboardUrl: "/relatorios-financeiro/dre",
        },
        {
          name: "905 - Monitor Financeiro",
          permissao: permissoesHelper.temPermisao(
            "relatorio-monitor-financeiro",
          ),
          dashboard: true,
          dashboardUrl: "/monitor-financeiro",
        },
      ],
    },
  ];

  useEffect(() => {
    buscarConfiguracoes();
  }, []);

  function buscarConfiguracoes() {
    configuracaoService.get().then((result) => {
      if (!result.isAxiosError) {
        setConfiguracoes((prevState) => ({
          ...prevState,
          jurosPorcentagem: result.data.rows[0]?.jurosPorcentagem ?? 0,
          multaPorcentagem: result.data.rows[0]?.multaPorcentagem ?? 0,
          carencia: result.data.rows[0]?.carencia ?? 0,
        }));
      }
    });
  }

  async function buscarContasReceberDetalhado(filtros) {
    setLoading(true);
    const result = await contasReceberService.getRelatorioDetalhado(filtros);
    if (!result.ok) {
      setLoading(false);
      responseErros(result);
      return {};
    }
    const blob = await responseStreamHelper.getBlobPdf(result);
    setLoading(false);
    await openAbaRelatorio(blob);
  }

  async function buscarContasPagarDetalhado(filtros) {
    setLoading(true);
    const result = await contasPagarService.getRelatorioDetalhado(filtros);
    if (!result.ok) {
      setLoading(false);
      responseErros(result);
      return {};
    }
    const blob = await responseStreamHelper.getBlobPdf(result);
    setLoading(false);
    await openAbaRelatorio(blob);
  }

  async function openAbaRelatorio(blob) {
    try {
      const url = URL.createObjectURL(blob);
      const pdfWindow = window.open(url, "_blank");
      if (!pdfWindow) {
        notification.alertaGenericos(
          "Popup bloqueado - por favor permita popups para este site",
        );
      }

      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error("Erro ao abrir PDF:", error);
      throw error;
    }
  }

  async function buscarRelatorioCaixaDetalhado(filtros) {
    setLoading(true);
    const result = await caixaService.getRelatorioDetalhado(filtros);
    if (!result.ok) {
      setLoading(false);
      responseErros(result);
      return {};
    }
    const blob = await responseStreamHelper.getBlobPdf(result);
    setLoading(false);
    await openAbaRelatorio(blob);
  }

  return (
    <RelatoriosLayout
      title="Relatório Contas a receber"
      subgruposRelatorios={subgruposRelatoriosFinanceiros}
      filtrosAplicadosImpressao={filtrosAplicadosImpressao}
      setFiltrosAplicadosImpressao={setFiltrosAplicadosImpressao}
      filtrosAvancados={filtrosAvancados}
      setFiltrosAvancados={setFiltrosAvancados}
      loading={loading}
      configuracoes={configuracoes}
    />
  );
};

export default RelatoriosFinanceiro;
